export const questions = [
  {
    'id': 'q1',
    'text': 'Площадь вашего жилья',
    'answers': [
      {
        'id': 'q1-1',
        'text': 'до 50 кв.м.',
        'value': 1,
      },
      {
        'id': 'q1-2',
        'text': '50 - 100 кв.м.',
        'value': 2,
      },
      {
        'id': 'q1-3',
        'text': 'больше 100 кв.м.',
        'value': 3,
      },
    ],
  },
  {
    'id': 'q2',
    'text': 'Насколько хорошо утеплено ваше жильё? (щели в стенах, сквозняк из окон и тп)',
    'answers': [
      {
        'id': 'q2-1',
        'text': 'Всё плохо, постоянные сквозняки, брррр',
        'value': 3,
      },
      {
        'id': 'q2-2',
        'text': 'Средне: иногда есть легкий сквозняк / холодная стена',
        'value': 2,
      },
      {
        'id': 'q2-3',
        'text': 'Нигде не сквозит, у меня хорошие окна и никаких щелей / холодных стен',
        'value': 1,
      },
    ],
  },
  {
    'id': 'q3',
    'text': 'Как часто надо поддерживать тепло в течение суток?',
    'answers': [
      {
        'id': 'q3-1',
        'text': 'Только ночуем, дома находимся меньше 10 часов в сутки',
        'value': 1,
      },
      {
        'id': 'q3-2',
        'text': 'С утра и до обеда дома никого нет: всё на работе / в школе',
        'value': 2,
      },
      {
        'id': 'q3-3',
        'text': 'У нас постоянно кто-то дома',
        'value': 3,
      },
    ],
  },
  {
    'id': 'q4',
    'text': 'Ваш регион',
    'answers': [
      {
        'id': 'q4-1',
        'text': 'У нас долгая холодная зима, мороз -20 и холоднее —  обычное дело',
        'value': 3,
      },
      {
        'id': 'q4-2',
        'text': 'Живу в средней полосе',
        'value': 2,
      },
      {
        'id': 'q4-3',
        'text': 'У нас достаточно теплая зима со средней температурой -10 и теплее',
        'value': 1,
      },
    ],
  },
];


export const results = [
  {
    gte: 4,
    lte: 5,
    text: 'Вам повезло! Не нужно срочно утеплять дом, да и сильных морозов в ваших краях не случается.',
    wood_volume: 2,
    wood_price: 6000,
    coal_volume: 3,
    coal_price: 30000,
    total_price: 36000,
  },
  {
    gte: 6,
    lte: 7,
    text: 'Всё не так уж и плохо, но топить точно придётся.',
    wood_volume: 3,
    wood_price: 9000,
    coal_volume: 4.5,
    coal_price: 45000,
    total_price: 54000,
  },
  {
    gte: 8,
    lte: 9,
    text: 'К зиме точно придется отложить немаленькую сумму (но бывает и хуже).',
    wood_volume: 4,
    wood_price: 12000,
    coal_volume: 6,
    coal_price: 60000,
    total_price: 72000,
  },
  {
    gte: 10,
    lte: 999,
    text: 'Ух! Зима - серьезное испытание для ваших финансов! Вы бы справились?',
    wood_volume: 5,
    wood_price: 15000,
    coal_volume: 8,
    coal_price: 80000,
    total_price: 95000,
  },
]
